const excludeColumns = ['action', 'checked', 'checkbox', 'expander'];

/**
 * Filter the data based on the keyword and search accessors
 * @param {*} obj - The object to search
 * @param {*} keyword - The keyword to search for 
 * @param {*} searchAccessors - The columns to search in
 * @returns 
 */
export const rowFilter = (obj, keyword, searchAccessors) => {
  let flag = false;
  const keys = Object.keys(obj);

  // Iterate over all keys in the object
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    // Check if the current key is in searchAccessors and not in exclude columns
    if (!excludeColumns.includes(key) && searchAccessors.includes(key)) {
      // Only search if the key is in the search accessors
      const value = obj[key];

      if (typeof value === 'string' && value.toLowerCase().includes(keyword.toLowerCase())) {
        console.log(`Data hit: key -> ${key}, value -> ${value.toLowerCase()}`);
        flag = true;
        break;
      }

      // If the value is an array, recursively search within the array
      if (Array.isArray(value)) {
        for (let j = 0; j < value.length; j++) {
          if (typeof value[j] === 'object' && value[j] !== null) {
            flag = rowFilter(value[j], keyword, searchAccessors);
          }
        }
      }
    }
  }
  return flag;
};

